import { useStore } from "vuex";

export const useAuth = () => {

    const store = useStore();

    const loginUser = async( user:any ) => {
        const resp = await store.dispatch('auth/loginUser', user);
        return resp;
    }
    /** Este componente se usa para obtener la sesión del usuario del backend
     * Se llama gerUserSession porque obtiene la sesión del back
     * Usa la mutación setUserSession porque guarda su valor en el store */ 
    const getUserSession = async( user:any ) => {
        await store.dispatch('auth/setUserSession', user);
    }

    /**
     * En este componente se solicita la sesión del usuario al back a partir del token de sesion
     * Se proporciona el token para recibir los datos de la sesion, si existe
     * @param jwt 
     */
    const getUserSessionJWT = async( jwt:any ) => {
        await store.dispatch('auth/setUserSessionJWT', jwt)
    }

    return {
        loginUser,
        getUserSession,
        getUserSessionJWT
    }

}

